import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemTotalQuantity } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemTotalQuantity/ItemTotalQuantity";
import { MediaItemEds } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemEds/MediaItemEds";
import React from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { EdsData } from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";

interface MediaItemCardWithActionsInnerChildProps {
  item: Item;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  edsData?: EdsData | null;
  itemCardRenderType?: ItemCardRenderType;
}

export const MediaItemCardWithActionsInnerChild = ({
  item,
  shouldDisplayQuantity = false,
  totalQuantityPieces,
  edsData,
  itemCardRenderType,
}: MediaItemCardWithActionsInnerChildProps) => {
  return (
    <>
      <ItemImage imageUrl={item.smallImageUrl || ""} />
      <div className={styles["item-card-root-column"]}>
        <ItemName name={item.name} />
        {itemCardRenderType &&
        itemCardRenderType === ItemCardRenderType.static ? (
          <ItemNoWithCopy itemNo={item.noFormatted} />
        ) : (
          <ItemNo itemNo={item.noFormatted} />
        )}
        <ItemDescription description={item.description || ""} />
        {shouldDisplayQuantity && totalQuantityPieces && (
          <ItemTotalQuantity totalPieces={totalQuantityPieces} />
        )}
        {edsData && <MediaItemEds edsData={edsData} />}
      </div>
    </>
  );
};
